import { render, staticRenderFns } from "./ShowModerator.vue?vue&type=template&id=3a37073c&"
import script from "./ShowModerator.vue?vue&type=script&lang=js&"
export * from "./ShowModerator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports